<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<mat-toolbar class="toolbar mat-elevation-z0">
    <mat-toolbar-row class="title">
        <div class="img-banner">
            <img class="cigent-logo" src="assets/Cigent_Logo_Light_R.webp" alt="Cigent Logo" />
            <img class="cigent-box" src="assets/cigent-box.jpg" alt="" />
        </div>
    </mat-toolbar-row>
</mat-toolbar>

<div class="thank-you" [ngClass]="isLoggedIn() ? 'dl-container with-sidebar' : 'dl-container'">
    <p>{{fThanks}}</p>
</div>
